import { render, staticRenderFns } from "./IntegraDetranPB.vue?vue&type=template&id=44d420ba"
import script from "./IntegraDetranPB.vue?vue&type=script&lang=js"
export * from "./IntegraDetranPB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports